import { TableColumnType } from 'antd';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { Compensation } from 'types';
import { formatDate, formatPeriod } from 'helpers';
import { getSorter } from 'helpers/get-sorter';
import { CompensationStatus, CompensationType, Namespace } from 'enums';
import { CompensationStatusItem } from 'components/common';

export const useCommonCompensationColumns = () => {
  const { t } = useTranslation();

  return useMemo<TableColumnType<Compensation>[]>(
    () => [
      {
        title: t('createdOn'),
        dataIndex: 'createdOn',
        sortDirections: ['descend', 'ascend', 'descend'],
        render: (createdOn) => formatDate(createdOn),
      },
      {
        title: t('targetPeriod'),
        dataIndex: 'targetPeriod',
        render: (targetPeriod) => formatPeriod(targetPeriod),
      },
      {
        title: t('compensationType'),
        dataIndex: 'type',
        render: (type: CompensationType) => <>{t(type, { ns: Namespace.CompensationTypes })}</>,
        sorter: getSorter<Compensation>((compensation) => t(compensation.type, { ns: Namespace.CompensationTypes })),
      },
      {
        title: t('status'),
        dataIndex: 'status',
        render: (status: CompensationStatus) => <CompensationStatusItem status={status} />,
        sorter: getSorter<Compensation>((compensation) =>
          t(compensation.status, { ns: Namespace.CompensationStatuses }),
        ),
      },
    ],
    [t],
  );
};
